export default __webpack_public_path__ + "static/media/404.de9f147c.png";